export const Success = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
            <circle cx="16.8398" cy="16.7222" r="16" fill="#378D69" />
            <circle cx="16.8398" cy="16.7222" r="12" fill="#5CEC96" />
            <rect x="22.5752" y="11.7222" width="2.4" height="12.8183" rx="1.2" transform="rotate(45 22.5752 11.7222)" fill="white" />
            <rect x="11.5371" y="15.3916" width="7.61032" height="2.4" rx="1.2" transform="rotate(45 11.5371 15.3916)" fill="white" />
        </svg>
    );
};
